import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'hotwarmcold',
  templateUrl: './hotwarmcold.component.html',
  styleUrls: ['./hotwarmcold.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class HotwarmcoldComponent {
  readonly status = input<string>('');
}
